import styled from '@emotion/styled';
import React from 'react';
import { Card as BootstrapCard } from 'react-bootstrap';
import { Theme } from '../../../../theme';
import {
  DuringBreak,
  Working,
} from '../../hooks/useCurrentTimeTrackingTimeline';
import CardHeaderDuringBreakStep from './CardHeaderDuringBreakStep';
import CardHeaderWorkingStep from './CardHeaderWorkingStep';
import { BreakTypeInfo } from '../BreakTypeIcon';
import { ExtraFieldInternalValue } from '../ExtraFields/extraFieldInternalValue';
import { ExtraFieldContextParam } from '../ExtraFields/types';

type Props = {
  step: Working | DuringBreak;
  notes: string | null;
  lastModifiedDate: string;
  accordionToggleKey: string;
  accordionOpen: boolean;
  accordionToggleOpen: () => void;
  breakTypes?: BreakTypeInfo[];
  extraFieldValues: readonly ExtraFieldInternalValue[];
  recordTypeName: string | null;
  contextParams: ExtraFieldContextParam[];
};

const Container = styled(BootstrapCard.Header)({
  backgroundColor: Theme.color.blue1,
});

const CardHeader: React.FC<React.PropsWithChildren<Props>> = ({
  step,
  notes,
  lastModifiedDate,
  accordionToggleKey,
  accordionOpen,
  accordionToggleOpen,
  breakTypes,
  extraFieldValues,
  recordTypeName,
  contextParams,
}) => (
  <Container>
    {step.kind === 'Working' ? (
      <CardHeaderWorkingStep
        step={step}
        notes={notes}
        lastModifiedDate={lastModifiedDate}
        accordionToggleKey={accordionToggleKey}
        accordionOpen={accordionOpen}
        accordionToggleOpen={accordionToggleOpen}
        breakTypes={breakTypes}
        extraFieldValues={extraFieldValues}
        recordTypeName={recordTypeName}
        contextParams={contextParams}
      />
    ) : (
      <CardHeaderDuringBreakStep
        step={step}
        accordionToggleKey={accordionToggleKey}
        accordionOpen={accordionOpen}
        accordionToggleOpen={accordionToggleOpen}
      />
    )}
  </Container>
);

export default CardHeader;
